<div mat-dialog-content>
  <p>
    Êtes vous sûr de vouloir modifier les quantités réceptionnées ?
  </p>
  <p>
    Après confirmation, une réclamation sera envoyée au service client,
    et vous ne pourrez plus modifier le bon de livraison.
  </p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="refuse()" color="white">Annuler</button>
  <button mat-raised-button color="primary" (click)="validate()">Confirmer</button>
</div>